export default __webpack_public_path__ + "static/media/fcl.a7e49c26.webp";